/**
 * Demo onboarding — founder video + industry + mobile preview.
 *
 * Welcome uses the existing founder YouTube walkthrough (same ID as the
 * marketing site). Swap `youtubeId` or set `videoUrl` to a self-hosted MP4
 * later without changing the overlay.
 */

export const FOUNDER_YOUTUBE_ID = "qN57k89IzLA";

export const WELCOME_VIDEO = {
  videoUrl: null,
  youtubeId: FOUNDER_YOUTUBE_ID,
  posterUrl: `https://i.ytimg.com/vi/${FOUNDER_YOUTUBE_ID}/hqdefault.jpg`,
  captionsUrl: null,
  durationHint: 90,
  script:
    "Hi, I'm Emrah — founder of RouteBot. This is the real product: routing on the dashboard, live tracking on the driver and parent apps.",
};

export const READY_VIDEO = {
  videoUrl: null,
  posterUrl: null,
  captionsUrl: null,
  durationHint: 8,
  script: "Your demo is ready. Take a look — then try optimizing a route in one click.",
};

/** Hotlinked from routebot.com — the same screenshots used on the /demo walkthrough. */
export const MOBILE_PREVIEWS = [
  {
    src: "https://routebot.com/routebot-driver-app-screen.jpg",
    label: "Driver app",
    caption: "Start the route, mark boardings, share live GPS",
  },
  {
    src: "https://routebot.com/blog-images/routebot-mobile-live-tracking.png",
    label: "Parent app",
    caption: "The bus on a live map, plus approaching alerts",
  },
];

export const ONBOARDING_INDUSTRIES = [
  {
    value: "school",
    emoji: "🚌",
    label: "School transportation",
    desc: "Students, parents & bus routes",
  },
  {
    value: "personnel",
    emoji: "🏢",
    label: "Employee transportation",
    desc: "Staff shuttles & shifts",
  },
  {
    value: "both",
    emoji: "🔀",
    label: "Both",
    desc: "Schools and employees",
  },
];

export const READY_MESSAGE_BY_INDUSTRY = {
  school: "We've tailored your demo for school transportation.",
  personnel: "We've tailored your demo for employee shuttle operations.",
  both: "We've tailored your demo for school & employee transportation.",
  default: "We've tailored your RouteBot demo for your operation.",
};

export const PREPARING_LINES = [
  "Placing stops on the map…",
  "Adding vehicles & drivers…",
  "Connecting the driver & parent apps…",
];
